module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/modal/parametro-entrada-moldal/parametro-entrada-modal.component.css
// module id = ./src/app/modal/parametro-entrada-moldal/parametro-entrada-modal.component.css
// module chunks = main